// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaginationList_pagination-list__iCDoW {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.PaginationList_pagination-item__K36pl {
  border-color: var(--light-grey);
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  line-height: 1.5;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
.PaginationList_pagination-item__K36pl.PaginationList_active__AEEPp {
  border-color: var(--blue);
  color: var(--blue);
}

@media only screen and (max-width: 480px) {
  .PaginationList_pagination-list__iCDoW {
    position: sticky;
    bottom: 8px;
    justify-content: center;
    background-color: white;
    border-radius: 8px;
    padding: 8px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/Pagination/PaginationList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AACF;;AAEA;EACE,+BAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AACF;AACE;EACE,yBAAA;EACA,kBAAA;AACJ;;AAGA;EACE;IACE,gBAAA;IACA,WAAA;IACA,uBAAA;IACA,uBAAA;IACA,kBAAA;IACA,cAAA;EAAF;AACF","sourcesContent":[".pagination-list {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.pagination-item {\n  border-color: var(--light-grey);\n  min-width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  line-height: 1.5;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n\n  &.active {\n    border-color: var(--blue);\n    color: var(--blue);\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .pagination-list {\n    position: sticky;\n    bottom: 8px;\n    justify-content: center;\n    background-color: white;\n    border-radius: 8px;\n    padding: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination-list": `PaginationList_pagination-list__iCDoW`,
	"pagination-item": `PaginationList_pagination-item__K36pl`,
	"active": `PaginationList_active__AEEPp`
};
export default ___CSS_LOADER_EXPORT___;
